import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLayer = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M21.9998 7.99899C21.9996 7.82052 21.9517 7.64535 21.8609 7.49166C21.7702 7.33798 21.64 7.21137 21.4838 7.12499L12.4618 2.12499C12.3136 2.04332 12.1471 2.00049 11.9778 2.00049C11.8086 2.00049 11.6421 2.04332 11.4938 2.12499L2.51582 7.08499C2.35986 7.17136 2.22981 7.29785 2.13916 7.45136C2.04851 7.60487 2.00055 7.77983 2.00025 7.95811C1.99994 8.13639 2.0473 8.31151 2.13742 8.46534C2.22755 8.61916 2.35715 8.7461 2.51282 8.83299L11.5348 13.873C11.6834 13.9564 11.8508 14.0004 12.0212 14.0005C12.1916 14.0007 12.3591 13.9571 12.5078 13.874L21.4858 8.87399C21.6418 8.78727 21.7717 8.6604 21.8621 8.50654C21.9524 8.35268 22 8.17744 21.9998 7.99899ZM12.0228 11.854L5.05982 7.96499L11.9768 4.14299L18.9408 8.00199L12.0228 11.854Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.5148 11.126L11.9998 15.856L3.48479 11.126L2.51379 12.874L11.5138 17.874C11.6623 17.9565 11.8294 17.9997 11.9993 17.9997C12.1692 17.9997 12.3363 17.9565 12.4848 17.874L21.4848 12.874L20.5148 11.126Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.5148 15.126L11.9998 19.856L3.48479 15.126L2.51379 16.874L11.5138 21.874C11.6623 21.9565 11.8294 21.9997 11.9993 21.9997C12.1692 21.9997 12.3363 21.9565 12.4848 21.874L21.4848 16.874L20.5148 15.126Z",
			fill: "currentColor"
		})
	]
});
export default SvgLayer;
